"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.employeeSizeOptions = exports.employeeRangeModifier = exports.MAX_FUNDING = exports.EMPLOYEE_SIZE_THRESHOLDS = exports.MAX_EMPLOYEES = void 0;
exports.MAX_EMPLOYEES = 10000;
// tslint:disable-next-line: no-magic-numbers
exports.EMPLOYEE_SIZE_THRESHOLDS = [0, 10, 50, 100, 250, 500, 1000, 5000, exports.MAX_EMPLOYEES];
exports.MAX_FUNDING = 100000000;
const employeeRangeModifier = (range) => {
    return [range[0] + 1, range[1]];
};
exports.employeeRangeModifier = employeeRangeModifier;
const employeeSizeOptions = (range) => {
    const [min, max] = range;
    const minIndex = exports.EMPLOYEE_SIZE_THRESHOLDS.indexOf(min);
    const maxIndex = exports.EMPLOYEE_SIZE_THRESHOLDS.indexOf(max);
    const result = [];
    if (maxIndex !== -1 && minIndex !== -1) {
        for (let index = minIndex; index <= maxIndex; index++) {
            const lower = exports.EMPLOYEE_SIZE_THRESHOLDS[index] + 1;
            const upper = exports.EMPLOYEE_SIZE_THRESHOLDS[index + 1];
            if (lower !== undefined && upper !== undefined && lower >= min && upper <= max) {
                const opt = `${lower}-${upper}`;
                result.push(opt);
            }
            if (upper === exports.MAX_EMPLOYEES && upper <= max) {
                result.push(`${upper + 1}+`);
            }
        }
    }
    return result;
};
exports.employeeSizeOptions = employeeSizeOptions;
//# sourceMappingURL=crunchbase-filters.js.map